var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "swiper-slide",
    [
      _c(
        "swiper",
        { ref: "postureBoneSwiper", attrs: { options: _vm.swiperOptions } },
        [
          _c("div", {
            staticClass:
              "swiper-pagination postureS-swiper-pagination content-row content-row-around",
            attrs: { slot: "pagination" },
            slot: "pagination"
          }),
          _vm._v(" "),
          _c("swiper-slide", [
            _c("div", { staticClass: "swiper-slide tab-content" }, [
              _c("div", { staticClass: "content-row content-row-center" }, [
                _c(
                  "div",
                  {
                    staticClass: "pc_marginTop",
                    staticStyle: { height: "30rem" }
                  },
                  [
                    _c("canvas", {
                      staticStyle: { height: "100%" },
                      attrs: { id: "faceBone", height: "1100", width: "600" }
                    })
                  ]
                ),
                _vm._v(" "),
                _vm.bodyPart.faceNormal == false
                  ? _c("span", { staticClass: "bone-desc" }, [
                      _c("div", { staticClass: "p1" }, [
                        _c("span", { staticClass: "radiodot" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "radiodotfont" }, [
                          _vm._v(_vm._s(_vm.$t("redAlert")))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "p2" }, [
                        _c("span", { staticClass: "radiodot" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "radiodotfont" }, [
                          _vm._v(_vm._s(_vm.$t("yellowAlert")))
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.bodyPart.faceNormal == true
                  ? _c("span", { staticClass: "body_normal" }, [
                      _vm._v(
                        _vm._s(_vm.$t("muscleDire.face")) +
                          _vm._s(_vm.$t("muscleDire.normal"))
                      )
                    ])
                  : _vm._e()
              ])
            ])
          ]),
          _vm._v(" "),
          _c("swiper-slide", [
            _c("div", { staticClass: "swiper-slide tab-content" }, [
              _c("div", { staticClass: "content-row content-row-center" }, [
                _c(
                  "div",
                  {
                    staticClass: "pc_marginTop",
                    staticStyle: { height: "30rem" }
                  },
                  [
                    _c("canvas", {
                      staticStyle: { height: "100%" },
                      attrs: { id: "sideBone", height: "1100", width: "600" }
                    })
                  ]
                ),
                _vm._v(" "),
                _vm.bodyPart.sideNormal == false
                  ? _c("span", { staticClass: "bone-desc" }, [
                      _c("div", { staticClass: "p1" }, [
                        _c("span", { staticClass: "radiodot" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "radiodotfont" }, [
                          _vm._v(_vm._s(_vm.$t("redAlert")))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "p2" }, [
                        _c("span", { staticClass: "radiodot" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "radiodotfont" }, [
                          _vm._v(_vm._s(_vm.$t("yellowAlert")))
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.bodyPart.sideNormal == true
                  ? _c("span", { staticClass: "body_normal" }, [
                      _vm._v(
                        _vm._s(_vm.$t("muscleDire.side")) +
                          _vm._s(_vm.$t("muscleDire.normal"))
                      )
                    ])
                  : _vm._e()
              ])
            ])
          ]),
          _vm._v(" "),
          _c("swiper-slide", [
            _c("div", { staticClass: "swiper-slide tab-content" }, [
              _c("div", { staticClass: "content-row content-row-center" }, [
                _c(
                  "div",
                  {
                    staticClass: "pc_marginTop",
                    staticStyle: { height: "30rem" }
                  },
                  [
                    _c("canvas", {
                      staticStyle: { height: "100%" },
                      attrs: { id: "backBone", height: "1100", width: "600" }
                    })
                  ]
                ),
                _vm._v(" "),
                _vm.bodyPart.backNormal == false
                  ? _c("span", { staticClass: "bone-desc" }, [
                      _c("div", { staticClass: "p1" }, [
                        _c("span", { staticClass: "radiodot" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "radiodotfont" }, [
                          _vm._v(_vm._s(_vm.$t("redAlert")))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "p2" }, [
                        _c("span", { staticClass: "radiodot" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "radiodotfont" }, [
                          _vm._v(_vm._s(_vm.$t("yellowAlert")))
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.bodyPart.backNormal == true
                  ? _c("span", { staticClass: "body_normal" }, [
                      _vm._v(
                        _vm._s(_vm.$t("muscleDire.back")) +
                          _vm._s(_vm.$t("muscleDire.normal"))
                      )
                    ])
                  : _vm._e()
              ])
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c3986d8a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3986d8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Posture_report.vue
// module id = null
// module chunks = 